module.exports = __webpack_public_path__ + "static/media/DSC09884.cfc84c34.jpg";